module.exports = __webpack_public_path__ + "static/media/store01.d9562624.jpg";